import { AxiosInstance, AxiosResponse } from 'axios'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'

export type RequestMethods = 'GET' | 'POST' | 'DELETE'

export default class AxiosRemoteContentService implements IRemoteContentService {
  constructor(private axios: AxiosInstance) {
    //
  }

  async request(method: RequestMethods, url: string, body?: object): Promise<AxiosResponse> {
    if (method === 'GET') {
      return await this.axios.get(url)
    }

    if (method === 'POST') {
      return await this.axios.post(url, body)
    }

    if (method === 'DELETE') {
      return await this.axios.delete(url, { data: body })
    }
  }
}
